import { Tooltip } from '@mui/material';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { FC } from 'react';
import { useAuth } from 'react-oidc-context';

const AuthorizedMenuItem: FC<MenuItemProps> = (props) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <MenuItem {...props} />
  ) : (
    <Tooltip title='Authorization required' placement='right' arrow followCursor>
      <MenuItem sx={{ color: 'text.disabled' }} {...props} />
    </Tooltip>
  );
};

export default AuthorizedMenuItem;
